
import Vue from "vue";
import Page from "@/components/Page.vue";
import Loader from "@/components/Loader.vue";

export default Vue.extend({
  name: "App",
  components: {
    Page,
    Loader
  },
  data() {
    return {
      nav: new Map([
        ["messwerte", "Aktuelle Messwerte"],
        ["station", "Informationen zur Station"],
        ["ganglinie", "30-Tage-Ganglinie"],
        // ["messung", "Chemische Messung"],
        ["download", "Download"]
      ]),
      id: this.$route.path.split("/")[1]
    };
  }
});
